import {
	FETCH_INITIAL_NAVIGATION_FULFILLED,
	SET_MOBILE_NAVIGATION_STATE_FULFILLED
} from '../constants/navigation.actions';

export const fetchInitialNavigationFulfilled = (nav) => {
	return {
		type: FETCH_INITIAL_NAVIGATION_FULFILLED,
		payload: {
			nav
		}
	};
};

export const closeMobileNav = () => ({
	type: SET_MOBILE_NAVIGATION_STATE_FULFILLED,
	payload: {
		open: false
	}
});

export const toggleMobileNav = open => ({
	type: SET_MOBILE_NAVIGATION_STATE_FULFILLED,
	payload: {
		open
	}
});
